import styled from 'styled-components'

export const AlertContainer = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
`
